import { render, staticRenderFns } from "./EvaluatorHostHistory.vue?vue&type=template&id=5bedf7a0&"
import script from "./EvaluatorHostHistory.vue?vue&type=script&lang=js&"
export * from "./EvaluatorHostHistory.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports